const DEFAULT_IMMICH_BASE_URL =
  "https://image.risingstarspublicschool.com/api";

export const IMMICH_BASE_URL = (() => {
  const configured = String(process.env.REACT_APP_IMMICH_BASE_URL || "").trim();
  if (!configured || configured === "/api") {
    return DEFAULT_IMMICH_BASE_URL;
  }
  return configured;
})().replace(/\/$/, "");
